// Import polyfills first
import './polyfills'
// Guest join links must not inherit a signed-in Sevv account (SC-323)
import './guestJoinBoot'

// Now import the rest of the modules
import 'regenerator-runtime/runtime'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import './index.scss'
import './theme/sevvTheme.scss'
import './theme/sevvThemeMapEditor.scss'
// NOTE: PhaserGame is now TRULY lazy loaded - it's not imported here at all.
// Phaser (~3MB) will only load when user joins a room, dramatically improving initial load time.
// See PhaserGame.ts for the lazy loading implementation.
import App from './App'
import store from './stores'
import { checkVersion } from './utils/versionCheck'
import { SevvDynamicThemeRoot } from './theme/SevvDynamicThemeRoot'
import { SessionProvider } from './contexts/SessionContext'

// Run version check first — if stale build detected, page reloads before React mounts
checkVersion()

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SevvDynamicThemeRoot>
        <SessionProvider>
          <App />
        </SessionProvider>
      </SevvDynamicThemeRoot>
    </Provider>
  </React.StrictMode>
)
